import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json";
import dkTranslation from "./locales/dk/translation.json";

i18n.use(HttpApi) // Load translations from HTTP
    .use(LanguageDetector) // Detect browser language
    .use(initReactI18next) // Bind React
    .init({
        resources: {
            en: { translation: enTranslation },
            dk: { translation: dkTranslation },
        },
        fallbackLng: "en", // Fallback language in case of missing translations
        supportedLngs: ["en", "dk"], // Supported languages
        debug: true,
        interpolation: { escapeValue: false },
        backend: {
            loadPath: "./locales/{{lng}}/translation.json", // Path to translations
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
        },
    });

export default i18n;
